import type { ReactNode } from 'react';
import { GraphQLProvider } from './ApolloProvider';
import { GoogleSdkProvider } from './GoogleSdkProvider';

export interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <GraphQLProvider>
      <GoogleSdkProvider>{children}</GoogleSdkProvider>
    </GraphQLProvider>
  );
}
